import React from 'react';

export const CalmPanel = ({ children, padding = '18px 20px', style = {}, accent = null, theme }) => {
  const accented = accent != null;
  const baseFill = theme?.colors?.bgCardSolid || '#1a1820';
  return (
    <div style={{
      background: accented
        ? `linear-gradient(135deg, ${accent.color}1a 0%, ${baseFill} 65%)`
        : baseFill,
      border: `1px solid ${accented ? `${accent.color}55` : 'rgba(255,255,255,0.08)'}`,
      borderRadius: 8,
      padding,
      boxShadow: accented ? `inset 0 0 40px -10px ${accent.glow}` : 'none',
      ...style,
    }}>
      {children}
    </div>
  );
};
